import { differenceInMinutes } from 'date-fns';
import { GanttConfig } from '../../Gantt/GanttConfig';
import { useSimulationMeta } from './useSimulationMeta';
import { useSimulationId } from './useSimulationId';

type SimulationBorderMarker = {
  toPublishBoundaryLeftDistance: number;
  freezeBoundaryLeftDistance?: number;
  toPublishBoundaryDate?: Date;
  freezeBoundaryDate?: Date;
  isVisible: boolean;
};

export const useSimulationBorderMarker = (startDate: Date, measureScale: number): SimulationBorderMarker => {
  const { id } = useSimulationId();
  const { data } = useSimulationMeta(String(id));

  if (!data?.planningBoundary) {
    return {
      toPublishBoundaryLeftDistance: 0,
      toPublishBoundaryDate: undefined,
      freezeBoundaryLeftDistance: 0,
      isVisible: false,
    };
  }

  const toPublishBoundaryDate = new Date(data.planningBoundary);
  const freezeBoundaryDate = data.freezingBoundary ? new Date(data.freezingBoundary) : undefined;

  return {
    toPublishBoundaryLeftDistance: calculateLeftDistance(toPublishBoundaryDate, startDate, measureScale),
    freezeBoundaryLeftDistance:
      freezeBoundaryDate && calculateLeftDistance(freezeBoundaryDate, startDate, measureScale),
    toPublishBoundaryDate,
    freezeBoundaryDate,
    isVisible: id !== 0,
  };
};

const calculateLeftDistance = (date: Date, startDate: Date, measureScale: number) => {
  const minutesDifference = differenceInMinutes(date, startDate);
  const hourDifference = minutesDifference / 60;
  const scaleFactor = GanttConfig.SINGLE_ELEMENT_WIDTH / measureScale;
  return hourDifference * scaleFactor;
};
